import { Box, FlexProps, useMultiStyleConfig } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { StylesProvider } from './Navigator';

export default function NavigatorScrollArea({ children, ...props }: PropsWithChildren & FlexProps) {
  const styles = useMultiStyleConfig('Navigator');
  return (
    <Box 
      __css={styles.navigatorScrollArea} 
      className="scroll"
      {...props}
    >
      <StylesProvider value={styles}>
        {children}
      </StylesProvider>
    </Box>
  )
}
